import { render } from "./DisplayModules.vue?vue&type=template&id=3384e5d0"
import script from "./DisplayModules.vue?vue&type=script&lang=js"
export * from "./DisplayModules.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__